import {DestroyRef, inject} from '@angular/core';
import {Observable} from 'rxjs';

export interface Destroyable {
    destroy$: Observable<any>;
}

/**
 * Returns stream bound to ngOnDestroy component's lifecycle hook.
 * @returns {Observable<any>}
 */
export function destroy$(destroyRef = inject(DestroyRef)): Observable<void> {
    return new Observable<void>(sub => {
        destroyRef.onDestroy(() => {
            sub.next();
            sub.complete();
        });
    });
}
